import { createAssistantRoutes } from '@agently/components';
import { lazyWithPreload } from '@agently/utils';

const AssistantPage = lazyWithPreload(() => import('pages/assistant/page'));

export const assistantRoutes = createAssistantRoutes({
  element: <AssistantPage />,
  loader: () =>
    import('pages/assistant/route-loader').then((module) =>
      module.assistantLoader(),
    ),
});
